export const GLOSSARY_HASH_ALIAS = 'glossary';
